<h2 mat-dialog-title class="warn-title">⚑ {{ readOnly ? 'Behavioural incident raised' : 'Report behavioural incident' }}</h2>

<div mat-dialog-content>
  <div class="tw:text-[13px] tw:font-semibold tw:text-[#333] tw:mb-3">{{ data.studentName }}</div>

  @if (readOnly) {
    <div class="tw:text-[11px] tw:text-[#888] tw:mb-1">Reason</div>
    <div class="tw:text-xs tw:text-[#333] tw:mb-3">{{ data.existingConcern.reason }}</div>
    <div class="tw:text-[11px] tw:text-[#888] tw:mb-1">Comments</div>
    <div class="tw:text-xs tw:text-[#333] tw:whitespace-pre-wrap tw:leading-[1.6]">{{ data.existingConcern.comments }}</div>
  } @else {
    <div class="tw:text-[11px] tw:text-[#888] tw:mb-3">The incident is saved with this session report. One incident can be raised per learner for this session.</div>

    <label class="field__label">Reason</label>
    <select class="field__control tw:w-full" [(ngModel)]="reason" required>
      <option value="">-- Select --</option>
      @for (r of reasons; track r) {
        <option [value]="r">{{ r }}</option>
      }
    </select>
    <span class="field__hint tw:block tw:text-[#c00] tw:text-[10px] tw:font-semibold">* required</span>

    <label class="field__label">Comments</label>
    <textarea class="field__control tw:w-full" [(ngModel)]="comments" rows="5" placeholder="Describe the behavioural incident…"></textarea>
    <span class="field__hint tw:block tw:text-[#c00] tw:text-[10px] tw:font-semibold">* required</span>
  }
</div>

<div mat-dialog-actions align="end">
  @if (readOnly) {
    <button mat-button (click)="dialogRef.close()">Close</button>
  } @else {
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button color="warn" [disabled]="!isValid" (click)="save()">Raise incident</button>
  }
</div>
